export default function downloadFileByBlob(blob: Blob, filename: string) {
    const pdfBlob = new Blob([blob], { type: blob.type })
    const url = URL.createObjectURL(pdfBlob)

    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.style.display = 'none'

    document.body.appendChild(a)
    a.click()

    document.body.removeChild(a)
    URL.revokeObjectURL(url)
}
